export default "__VITE_ASSET__aBOqagqF__"